import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { finalizeMeterUpload } from "@services/bulkMeterUpload";

export const useFinalizeMeterUpload = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, rowIds }: { id: string; rowIds: string[] }) =>
      finalizeMeterUpload(id, rowIds),
    {
      ...options,
      onSuccess: (res, vars) => {
        queryClient.invalidateQueries({ queryKey: ["meterUploads"] });
        queryClient.invalidateQueries({ queryKey: ["meterUpload", vars.id] });
        if (isFunction(onSuccess)) onSuccess(res, vars);
      },
    },
  );
};
